"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _FilterBar = require("./FilterBar.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 篩選bar
 */
var FilterBar = function FilterBar(_ref) {
  var _onChange = _ref.onChange,
      children = _ref.children,
      prevChildren = _ref.prevChildren;
  return /*#__PURE__*/_react.default.createElement(_FilterBar.UiFilterBar, null, prevChildren, /*#__PURE__*/_react.default.createElement(_FilterBar.UiSearchInput, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "search",
    color: "#fff"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    placeholder: "\u641C\u5C0B...",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_FilterBar.UiFilterCondition, null, children));
};

var _default = FilterBar;
exports.default = _default;
FilterBar.propTypes = {
  onChange: _propTypes.default.func,
  children: _propTypes.default.node,
  prevChildren: _propTypes.default.node
};